import React, { useContext, useEffect, useState } from "react";
import {
  Logo,
  SmallLogo,
  Closes,
  HeaderSearch,
  Flag,
  FlagUS,
  FlagFR,
  FlagES,
  FlagDE,
  Notification,
  Avatar2,
  Avatar3,
  Avatar6,
  Avatar17,
  Avatar13,
  Avatar,
  Logout,
  Noimage,
} from "../../../common/imagePath";
import { Link } from "react-router-dom";
import { checkUserPermission } from "../../../common/UserPermission";
import Select from "react-select";
import config from "../../../config/config";
import axios from "axios";
import { toastSuccess } from "../../../common/Toast";
import { SUCCESS_MESSAGE } from "../../../common/Constant";
import Loader from "../../../components/Loader/Loader";
import { useNavigate } from "react-router-dom";
import loadingimage from "../../../assets/img/loading-svg.svg"
import { AppContext } from "../../../context/AppContext";

const Header = () => {
  const [changeImagename, setChangeImagename] = useState(false);
  const [searchBar, SetSearchBar] = useState(false);
  const [toggle, SetToggle] = useState(false);
  const Id = localStorage.getItem("ID");
  const loginuserid = localStorage.getItem("ID");
  const navigate = useNavigate();
  const Name = localStorage.getItem("Name");
  const EmailId = localStorage.getItem("EmailId");
  const Selectimage = localStorage.getItem("Selectimage");
  const [locationDropdown, setLocationDropdown] = useState([]);
  const token = localStorage.getItem("Token");
  const [selectedlocation, setSelectedLocation] = useState(0);
  const [loading, setLoading] = useState(false);
   const [Label, setLabel] = useState(false);
  // const {Label,UserRoles} = useContext(AppContext)
  // console.log(UserRoles,"798798");
   
  const[companyname , setcompanyname] = useState("")
  const [cursor, setcursor] = useState(0);
  const [inputValue, setInputValue] = useState("");
  const [Image, setImage] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  // const debounceRef = useRef(null);

  console.log(Selectimage, "123000")
  
  const fetchData = async () => {
    if (inputValue != "") {
      axios
        .get(
          `${config.generalBaseUrl}/generals/globalsearch?inputvalue=${inputValue}&loginuserId=${Id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((response) => {
          // if (response != "" && response != null) {
          const data = response.data.ResponseData;

          setSuggestions(data);

          // setSuggestions([]);
          // }
        })
        .catch((error) => {});
    } else {
      setSuggestions([]);
    }
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    setInputValue(event.target.value);

    if (!value) {
      setSuggestions([]);
    }
  };
  console.log(suggestions, "154215424");
  useEffect(() => {
    const timer = setTimeout(() => {
      fetchData(inputValue);
    }, 500);
    return () => {
      clearTimeout(timer);
    };
  }, [inputValue]);

  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
    SetToggle((current) => !current);
  };

  const expandMenu = () => {
    document.body.classList.remove("expand-menu");
  };

  const expandMenuOpen = () => {
    document.body.classList.add("expand-menu");
  };

  const sidebarOverlay = () => {
    document.querySelector(".main-wrapper").classList.toggle("slide-nav");
    document.querySelector(".sidebar-overlay").classList.toggle("opened");
    document.querySelector("html").classList.toggle("menu-opened");
  };

  // let navigate = useNavigate();

  const signOut = () => {
    // for (const key in localStorage) {
    //   if (localStorage.hasOwnProperty(key) && key !== 'QuickbookStatus') {
    //     localStorage.removeItem(key);
    //   }
    // }
    localStorage.clear();

    sessionStorage.clear();

    // navigate("/login");
    window.location.href = "/login";
  };

  useEffect(() => {
    if(Label == true){
      setChangeImagename(false)
    }
    axios
      .get(`${config.locationBaseUrl}/locations/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        const filteredData = res.data.ResponseData?.filter((el) =>
          locationarray?.includes(el?.Id)
        );
        console.log(filteredData, "filteredDatadropdown");
        setLocationDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  let pathname = window.location.pathname;
  const location = localStorage.getItem("Location");
  const locationvariable = JSON.parse(localStorage.getItem("LocationVariable"));
  const locationarray =
    locationvariable?.LocationID !== undefined
      ? locationvariable?.LocationID?.split(",")
      : [];
  console.log(locationvariable, locationarray, "locationarray");

  let locationDropdownOption = [];
  const Dropdown = locationDropdown.map((u, i) => {
    if (
      locationarray?.includes(`${u.Id}`) &&
      !locationvariable?.isAdmin !== "true"
    )
      locationDropdownOption[i] = { label: u.Name, value: u.Id };
  });

  useEffect(() => {
    setSelectedLocation(location);
  }, [location]);
  useEffect(() => {
    axios
      .get(
        `${config.quickbooksBaseUrl}/quickbooks/gettoken?loginuserid=${loginuserid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
          },
        }
      )

      .then((res) => {
        setChangeImagename(false);
        // alert(JSON.stringify(res.data))
        const data = res.data.ResponseData[0];
        if (data.Isconnected == 1) {
          setLabel(true);

          // localStorage.setItem("QuickbookStatus",true)
        }
      })
      .catch((err) => {
        console.log(err);
      });


      axios
      .get(
        `${config.quickbooksBaseUrl}/quickbooks/companyname?loginuserid=${loginuserid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
          },
        }
      )

      .then((res) => {
       console.log(res?.data,"###");
       setcompanyname(res?.data)
      })
      .catch((err) => {
        console.log(err);
      });

      
      axios
      .get(
        `${config.storeConfigBaseUrl}/storeconfig/CompanyInformation`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )

      .then((res) => {
       console.log(res?.data,"###");
       setImage(res.data.ResponseData)
      })
      .catch((err) => {
        console.log(err);
      });
      
      
  }, []);
  // useEffect(()=>{
  //   locationDropdown.map((u, i) => {
  //     console.log(locationarray?.includes(Number(u.Id)), u.I)
  //     if(locationarray?.includes(Number(u.Id))){
  //       locationDropdownOption[i] = { label: u.Name, value: u.Id };
  //     }
  //   });
  // },[locationarray])

  const selectStyles = {
    // dropdown input css
    control: (provided, state) => ({
      ...provided,
      width: "111%",
      height: "40px",
      marginTop: "10px",
      // marginLeft: "20px",
      position: "relative",
      border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
      "&:hover": {
        border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      },
    }),
    // dropdown menu css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
      position: "absolute",
      "z-index": "999",
      background: "#f8f8f8",
      width: "111%",
    }),
    // dropdown option css
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
      "&:hover": {
        backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
      },
    }),
  };

  // console.log(locationname,"locationname")

  const handleWarehouse = (e) => {
    console.log(e, "event");
    localStorage.setItem("Location", e.value);
    setSelectedLocation(e.value);

    setLoading(true);
    axios
      .post(
        `${config.authenticationBaseUrl}/users/locationupsert`,
        {
          loginuserid: Id,
          locationid: e.value,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // console.log("res ==> ", res.data.ResponseData);

        //  toastSuccess(SUCCESS_MESSAGE);
        console.log(res.data);
        window.location.reload();
        //  setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });

    //  location=localStorage.getItem("Location")
  };

  console.log(selectedlocation, "selectedlocation");
  return (
    <>
      <Loader loading={loading} />
      <div className="header">
        {/* Logo */}
        <div
          className={`header-left ${toggle ? "" : "active"}`}
          onMouseLeave={expandMenu}
          onMouseOver={expandMenuOpen}
        >
          <Link to="/dashboard" className="logo">
            <img src={Image[0]?.CompanyLogo } alt="" />
          </Link>
          <Link to="/dashboard" className="logo-small">
            <img src={Image[0]?.favicon } alt="" style={{width:"50px"}} />
          </Link>

          <Link
            id="toggle_btn"
            to="#"
            style={{
              display: pathname.includes("tasks")
                ? "none"
                : pathname.includes("compose")
                ? "none"
                : "",
            }}
            onClick={handlesidebar}
          ></Link>
        </div>
        {/* /Logo */}
        <Link
          id="mobile_btn"
          className="mobile_btn"
          to="#"
          onClick={sidebarOverlay}
        >
          <span className="bar-icon">
            <span />
            <span />
            <span />
          </span>
        </Link>
        {/* Header Menu */}

        {/* <div className="w-50 border border-primary"> */}

        <ul className={searchBar ? "nav user-menu  " : "nav user-menu  "}>


          {changeImagename == true ? (
            <div
              style={{
                // border: "1px ",
                // borderRadius: "4px",
                display: "flex",
                padding: "5px",
                marginTop: "5px",
                cursor: "pointer",
                // color: Label === true ? "green" : "red",
              }}
            >
              <img
                style={{ height: "26x", width: "26px" }}
                src="https://sonarposdev1.s3.amazonaws.com/sync+loader.svg"
              />{" "}
              <span style={{ marginTop: "14px", marginLeft: "4px" }}>
                {" "}
                Quickbook
              </span>
            </div>
          ) : (
            // <p></p>
            <div className="me-2" style={{ marginTop: "10px" }}>
              <div
                style={{
                  // border: "1px ",
                  // borderRadius: "4px",
                  padding: "5px",
                  marginTop: "5px",
                  cursor: "pointer",
                  // color: Label === true ? "green" : "red",
                }}
                onClick={() => navigate("/quickbooksync")}
                
              >
                {Label === true ? (
                  <div title="QuickBook Connected">
                    <i
                      className="fa fa-circle"
                      style={{ fontSize: "16px", color: "green" }}
                    ></i>{" "}
                    <span style={{ fontSize: "14px" }} >
                      QB  {companyname}
                    </span>
                  </div>
                ) : (
                  <div title="QuickBook Disconnected">
                    <i
                      className="fa fa-circle"
                      style={{ fontSize: "16px", color: "red" }}
                    ></i>{" "}
                    <span style={{ fontSize: "14px" }}>
                      QB {companyname}
                    </span>
                  </div>
                )}
              </div>

              {/* <Link
            to="/quickbooksync"
            className={Label === true ? "btn btn-outline-success" : "btn btn-outline-danger"}
            style={{
              height:"fit-content",
              
            }}
          >
            {Label === true ? (
              <>
                <i className="fa fa-check-circle"></i> Quickbooks
              </>
            ) : (
              <>
                <i className="fa fa-times-circle"></i> Quickbooks
              </>
            )}
          </Link> */}
            </div>
          )}


<div className="mt-3 nav user-menu" style={{ position: "relative" , paddingRight:"0px"}}>
  <input
    style={{
      width: "320px",
      height: "36px",
      borderRadius: "5px",
      border: "2px solid #dbdada",
      padding: "0px 14px",
    }}
    type="text"
    placeholder="Search Here...."
    value={inputValue}
    onChange={handleInputChange}
  />
  {suggestions.length === 0  && inputValue !== "" &&(
    <div style={{ position: "absolute", right: "10px", top: "10px" }}>
      <img src={loadingimage} alt="Loading..." style={{ width: "20px", height: "20px" }} />
    </div>
  )}
  {suggestions.length > 0 && (
    <div
      className="dropdown"
      style={{
        position: "absolute",
        top: "-60px",
        left: "0",
        width: "100%",
        zIndex: "1000",
        backgroundColor: "white",
        border: "1px solid #ccc",
        borderRadius: "4px",
      }}
    >
      <ul
        className="dropdown-menu show"
        style={{
          maxHeight: "400px",
          overflowY: "auto",
          padding: "2px 10px",
          listStyle: "none",
          margin: "0",
          width: "auto",
        }}
      >
        {suggestions.map((item, index) => (
          <li
            style={{ padding: "0px 10px" }}
            key={item.ID}
            className={
              cursor === index
                ? "dropdown-item active"
                : "dropdown-item"
            }
          >
            <a
              href={`${item?.Result_Route}${
                item?.TableName == "ReportDropdownList" ? "" : `/${item?.ID}`
              }`}
              className={
                cursor === index
                  ? "dropdown-item active"
                  : "dropdown-item"
              }
              target="_blank"
              data-name={item.MatchedValue.toUpperCase()}
            >
              <div className="customer-info ml-2">
                <h6 className="name">
                  <ul>
                    <li
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span
                        style={{ fontSize: "14px", fontWeight: "500" }}
                      >
                        {item.TableName}
                      </span>
                      <span
                        style={{
                          marginLeft: "36px",
                          fontSize: "12px",
                          fontWeight: "400",
                        }}
                      >
                        {item.MatchedColumnName}
                        {" | "}
                        {item.ProcessedMatchedValue}{" "}
                        {/* {parseFloat(item.MatchedValue).toFixed(2)}                                                    */}
                        {/* {typeof item.MatchedValueType === 'String' ? item.MatchedValue : Number(item.MatchedValue).toFixed(2)} */}
                      </span>
                    </li>
                  </ul>
                </h6>
              </div>
            </a>
          </li>
        ))}
      </ul>
    </div>
  )}
</div>

          {/* Search */}
          <div style={{padding: "10px 6px -1px 5px"}} className="me-2">
            <Link
              to="https://reliabledistributor.com/"
              // to={Image[0]?.Website}
              className="btn btn-primary btn-sm pull-right"
              style={{
                width: "max-content",
                marginLeft: "15px",
                marginTop: "10px",
              }}
              target="_blank"
            >
              Visit Site
            </Link>
          </div>
          {/* <div className={searchBar ? "w-3" : "w-5"}> */}
          {/* {locationarray?.length > 1 ?  */}
          <li className="nav mr-3">
            {/* <select class="form-select mr-2" aria-label="Default select example" >
            <option selected>{locationname}</option>
            <option value={locationname=="Warehouse 1"? "Warehouse 2": "Warehouse 1"}>{locationname=="Warehouse 1"? "Warehouse 2": "Warehouse 1"}</option>
            </select> */}
            <Select
              value={locationDropdownOption?.find(
                (option) => option?.value == selectedlocation
              )}
              options={locationDropdownOption}
              placeholder="Warehouse"
              backspaceRemovesValue={false}
              controlShouldRenderValue={true}
              hideSelectedOptions={true}
              isClearable={true}
              styles={selectStyles}
              onChange={(event) => handleWarehouse(event)}
            />
          </li>
          {/* : ""} */}

          {/* {searchBar ?

            <li className="nav-item ml-5">



              <div className="top-nav-search  ">

               

                <form action="#">



                  <div className={`searchinputs ${searchBar ? "show " : ""}`}>
                    <input type="text" placeholder="Search Here ..." />
                    <div
                      className="search-addon"
                      onClick={() => SetSearchBar(false)}
                    >
                      <span>
                        <img src={Closes} alt="img" />
                      </span>
                    </div>
                  </div>


                </form>
              </div>
            </li> : ""} */}

          {/* <div>

            <li className="nav-item mt-2 ml-3">
              <Link
                to="#"
                className="btn"
                id="searchdiv"
                onClick={() => SetSearchBar(true)}
              >
                <img src={HeaderSearch} alt="img" />
              </Link>
            </li>
          </div> */}

          {/* /Search */}
          {/* Flag */}

          {/* <li className="nav-item dropdown has-arrow flag-nav">
            <Link
              to="#"
              className="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
              role="button"
            >
              <img src={Flag} alt="" height={20} />
            </Link>
            <div className="dropdown-menu dropdown-menu-right">
              <Link to="#" className="dropdown-item">
                <img src={FlagUS} alt="" height={16} /> English
              </Link>
              <Link to="#" className="dropdown-item">
                <img src={FlagFR} alt="" height={16} /> French
              </Link>
              <Link to="#" className="dropdown-item">
                <img src={FlagES} alt="" height={16} /> Spanish
              </Link>
              <Link to="#" className="dropdown-item">
                <img src={FlagDE} alt="" height={16} /> German
              </Link>
            </div>
          </li>
           */}

          {/* /Flag */}
          {/* Notifications */}

          {/* <li className="nav-item dropdown">
            <Link
              to="#"
              className="dropdown-toggle nav-link"
              data-bs-toggle="dropdown"
            >
              <img src={Notification} alt="img" className="noti-image" />
              <span className="badge rounded-pill">4</span>
            </Link>
            <div className="dropdown-menu notifications">
              <div className="topnav-dropdown-header">
                <span className="notification-title">Notifications</span>
                <Link to="#" className="clear-noti">
                  {" "}
                  Clear All{" "}
                </Link>
              </div>
              <div className="noti-content">
                <ul className="notification-list">
                  <li className="notification-message">
                    <Link to="/activities">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <img alt="" src={Avatar2} />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">John Doe</span> added
                            new task{" "}
                            <span className="noti-title">
                              Patient appointment booking
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              4 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li className="notification-message">
                    <Link to="/activities">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <img alt="" src={Avatar3} />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">Tarah Shropshire</span>{" "}
                            changed the task name{" "}
                            <span className="noti-title">
                              Appointment booking with payment gateway
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              6 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li className="notification-message">
                    <Link to="/activities">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <img alt="" src={Avatar6} />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">Misty Tison</span>{" "}
                            added{" "}
                            <span className="noti-title">Domenic Houston</span>{" "}
                            and <span className="noti-title">Claire Mapes</span>{" "}
                            to project{" "}
                            <span className="noti-title">
                              Doctor available module
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              8 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li className="notification-message">
                    <Link to="/activities">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <img alt="" src={Avatar17} />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">Rolland Webber</span>{" "}
                            completed task{" "}
                            <span className="noti-title">
                              Patient and Doctor video conferencing
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              12 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li className="notification-message">
                    <Link to="/activities">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <img alt="" src={Avatar13} />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">Bernardo Galaviz</span>{" "}
                            added new task{" "}
                            <span className="noti-title">
                              Private chat module
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              2 days ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="topnav-dropdown-footer">
                <Link to="/activities">View all Notifications</Link>
              </div>
            </div>
          </li> */}

          {/* /Notifications */}
          <li className="nav-item dropdown has-arrow main-drop">
            <Link
              to="#"
              className="dropdown-toggle nav-link userset"
              data-bs-toggle="dropdown"
            >
              <span className="user-img mt-2">
                <img
                  src='data:image/png;base64,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'
                  onError={(e) => {
                    e.target.onError = null;
                    e.target.src = Noimage;
                  }}
                  alt=""
                />
              </span>
            </Link>
            <div className="dropdown-menu menu-drop-user">
              <div className="profilename">
                <div className="profileset">
                  <span className="user-img mt-2">
                    <img
                      src='data:image/png;base64,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'
                      onError={(e) => {
                        e.target.onError = null;
                        e.target.src = Noimage;
                      }}
                      alt=""
                    />
                    {/* <span className="status online" /> */}
                  </span>
                  <div className="profilesets">
                    <h6>{Name}</h6>
                    <p className="email">{EmailId}</p>
                  </div>
                </div>
                <hr className="m-0" />
                {checkUserPermission("/edit-profile") && (
                  <Link className="dropdown-item" to={`/edit-profile`}>
                    <i className="me-2" data-feather="user" /> My Profile
                  </Link>
                )}
                {checkUserPermission("settings") && (
                  <Link className="dropdown-item" to="/storeconfig">
                    <i className="me-2" data-feather="settings" />
                    Settings
                  </Link>
                )}
                <hr className="m-0" />
                <Link className="dropdown-item logout pb-0" onClick={signOut}>
                  <img src={Logout} className="me-2" alt="img" />
                  Logout
                </Link>
              </div>
            </div>
          </li>
        </ul>

       

        {/* </div> */}
        {/* /Header Menu */}
        {/* Mobile Menu */}
        <div className="dropdown mobile-user-menu">
          <Link
            to="#"
            className="nav-link dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link className="dropdown-item" to={`/edit-profile/${Id}`}>
              My Profile
            </Link>
            <Link className="dropdown-item" to="/storeconfig">
              Settings
            </Link>
            <Link className="dropdown-item" onClick={signOut}>
              Logout
            </Link>
          </div>
        </div>
        {/* /Mobile Menu */}
      </div>
    </>
  );
};

export default Header;
